import { lazy } from 'react'

export const StopHunger = lazy(() => import('./StopHunger'))
